<template>
  <section class="rounded-3xl border border-gray-100 bg-white p-6 shadow-sm">
    <div class="flex flex-wrap items-center justify-between gap-3">
      <div>
        <h2 class="text-lg font-semibold text-ink">Add package</h2>
        <p class="text-sm text-muted">Create a new vendor package.</p>
      </div>
      <RouterLink to="/dashboard/packages" class="text-xs font-semibold text-brand">Back to packages</RouterLink>
    </div>

    <form class="mt-6 grid gap-4 sm:grid-cols-2" @submit.prevent="handleSubmit">
      <label class="block">
        <span class="text-xs font-semibold uppercase tracking-wide text-muted">Title</span>
        <input v-model.trim="form.title" type="text" placeholder="Signature soirée" class="mt-2 w-full rounded-xl border border-gray-200 px-4 py-3 text-sm text-ink shadow-sm focus:border-brand focus:outline-none">
      </label>
      <label class="block sm:col-span-2">
        <span class="text-xs font-semibold uppercase tracking-wide text-muted">Description</span>
        <textarea v-model.trim="form.description" rows="3" placeholder="Describe what is included" class="mt-2 w-full rounded-xl border border-gray-200 px-4 py-3 text-sm text-ink shadow-sm focus:border-brand focus:outline-none"></textarea>
      </label>
      <label class="block">
        <span class="text-xs font-semibold uppercase tracking-wide text-muted">Price</span>
        <input v-model.number="form.price" type="number" placeholder="9800" class="mt-2 w-full rounded-xl border border-gray-200 px-4 py-3 text-sm text-ink shadow-sm focus:border-brand focus:outline-none">
      </label>
      <label class="block">
        <span class="text-xs font-semibold uppercase tracking-wide text-muted">Price per</span>
        <select v-model="form.price_per" class="mt-2 w-full rounded-xl border border-gray-200 px-4 py-3 text-sm text-ink shadow-sm focus:border-brand focus:outline-none">
          <option value="">Select</option>
          <option value="per_day">per_day</option>
          <option value="per_month">per_month</option>
          <option value="per_event">per_event</option>
          <option value="per_request">per_request</option>
          <option value="on_request">on_request</option>
        </select>
      </label>
      <p v-if="error" class="sm:col-span-2 text-xs font-semibold text-red-600">{{ error }}</p>
      <div class="flex flex-wrap gap-3 sm:col-span-2">
        <button type="submit" class="rounded-full bg-brand px-4 py-2 text-xs font-semibold text-white shadow-sm transition hover:bg-brandDark" :disabled="loading">
          {{ loading ? 'Saving...' : 'Save package' }}
        </button>
        <button type="button" class="rounded-full border border-gray-200 px-4 py-2 text-xs font-semibold text-ink transition hover:border-brand hover:text-brand">
          Cancel
        </button>
      </div>
    </form>
  </section>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { RouterLink, useRouter } from 'vue-router'
import api from '@/services/api'
import { getAuthUserId } from '@/services/auth'

const router = useRouter()
const loading = ref(false)
const error = ref('')

const form = reactive({
  vendor_id: getAuthUserId(),
  title: '',
  description: '',
  price: '',
  price_per: ''
})

const handleSubmit = async () => {
  error.value = ''
  loading.value = true
  const payload = new FormData()
  Object.entries(form).forEach(([key, value]) => payload.append(key, value ?? ''))

  try {
    await api.addVendorPackage(payload)
    router.push('/dashboard/packages')
  } catch (err) {
    error.value = err?.response?.data?.message || err?.message || 'Failed to save package'
  } finally {
    loading.value = false
  }
}
</script>
